module.exports = __webpack_public_path__ + "img/backimg4.4d82dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backimg4.png
// module id = A2p/
// module chunks = 2